import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {JhiLanguageService} from 'ng-jhipster';
import {EntityAuditEvent} from './entity-audit-event.model';
import {EntityAuditEventService} from './entity-audit-event.service';

@Component({
    selector: 'jhi-entity-audit-event-detail',
    templateUrl: './entity-audit-event-detail.component.html'
})
export class EntityAuditEventDetailComponent implements OnInit, OnDestroy {

    entityAuditEvent: EntityAuditEvent;
    private subscription: any;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private entityAuditEventService: EntityAuditEventService,
        private route: ActivatedRoute
    ) {
        this.jhiLanguageService.setLocations(['entityAuditEvent']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe(params => {
            this.load(params['id']);
        });
    }

    load (id) {
        this.entityAuditEventService.find(id).subscribe(entityAuditEvent => {
            this.entityAuditEvent = entityAuditEvent;
        });
    }

    // noinspection JSMethodCanBeStatic
    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    // noinspection JSMethodCanBeStatic
    toJsonObject(entity: any) {
        try {
            return JSON.parse(entity);
        }
        catch (err) {
            return entity;
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/entity-audit-event/entity-audit-event-detail.component.ts